module.exports = __webpack_public_path__ + "img/tool4.975fdee9.png";